import React from "react";

// reactstrap components
import { Container, Row, Table } from "reactstrap";

// core components

function SectionClassTimes() {
  return (
    <div>
      <Container className="tim-container">
        <div>
          <Row
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div className="typography-line">
              <h3 style={{ textTransform: "uppercase" }}>
                CLASS TIMES - Normal Practice Schedule
              </h3>
              <h4>Magister Hall, Garsfontein Dojo</h4>
              <br />
              <h6>Monday and Wednesday</h6>
              <br />
              <Table>
                <thead>
                  <tr>
                    <th>Class</th>
                    <th>Time slot</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Minis</td>
                    <td>15:20 – 15:50</td>
                  </tr>
                  <tr>
                    <td>Junior Beginners, White to Orange 1</td>
                    <td>16:00 – 16:45</td>
                  </tr>
                  <tr>
                    <td>Junior Intermediary, ages 6-12, Orange to Blue</td>
                    <td>16:50 – 17:35</td>
                  </tr>
                  <tr>
                    <td>Senior Beginners, age 13 and up to Junior Brown</td>
                    <td>17:40 – 18:25</td>
                  </tr>
                  <tr>
                    <td>Senior Brown and up</td>
                    <td>18:30 – 19:30</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </Row>
        </div>
      </Container>
      <div className="section section-dark" style={{ color: "white" }}>
        <Container style={{ color: "white" }}>
          <h4>NG Church Hall, Faerie Glen Dojo</h4>
          <br />
          <h6>Tuesday and Thursday</h6>
          <br />
          <Table style={{ color: "white" }}>
            <thead>
              <tr>
                <th>Class</th>
                <th>Time slot</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Junior Beginners, White to Orange 1</td>
                <td>16:00 – 16:45</td>
              </tr>
              <tr>
                <td>Junior Intermediary, ages 6-12, Orange to Blue</td>
                <td>16:50 – 17:35</td>
              </tr>
              <tr>
                <td>Purple and up</td>
                <td>17:40 – 18:25</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </Table>
        </Container>
      </div>
      <Container className="tim-container">
        <div>
          <Row
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div className="typography-line">
              <h4>KPC and Shodan Preparation classes</h4>
              <br />
              <h6>Tuesday, NG Church Hall / Friday, Magister Hall</h6>
              <br />
              <Table>
                <thead>
                  <tr>
                    <th>Class</th>
                    <th>Time slot</th>
                    <th>Days</th>
                    <th>Venue</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>KPC Elite Kumite</td>
                    <td>17:40 – 18:25</td>
                    <td>Tuesday</td>
                    <td>NG Church Hall, Faerie Glen</td>
                  </tr>
                  <tr>
                    <td>KPC Elite Kumite</td>
                    <td>14:45 – 15:45</td>
                    <td>Fridays</td>
                    <td>Magister Hall, Menlyn</td>
                  </tr>
                  <tr>
                    <td>KPC Kata</td>
                    <td>16:00 – 16:45</td>
                    <td>Fridays</td>
                    <td>Magister Hall, Menlyn</td>
                  </tr>

                  <tr>
                    <td>KPC Development Kumite</td>
                    <td>16:00 – 16:45</td>
                    <td>Fridays</td>
                    <td>Magister Hall, Menlyn</td>
                  </tr>
                  <tr>
                    <td>Senior Grading Classes</td>
                    <td>17:00 – 17:45</td>
                    <td>Fridays</td>
                    <td>Magister Hall, Menlyn</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </Row>
        </div>
      </Container>
      <div className="section section-dark" style={{ color: "white" }}>
        <Container style={{ color: "white" }}>
          <h3 style={{ textTransform: "uppercase" }}>
            Holiday Practice Schedule
          </h3>
          <p>During the holidays, our time-table changes slightly</p>
          <h4>Magister Hall, Garsfontein Dojo</h4>
          <br />
          <h6>Monday and Wednesday</h6>
          <br />
          <Table style={{ color: "white" }}>
            <thead>
              <tr>
                <th>Class</th>
                <th>Time slot</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>White to Red Belts</td>
                <td>17:00 – 17:45</td>
              </tr>
              <tr>
                <td>Brown to Black Belts</td>
                <td>18:00 – 19:00</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </Table>
        </Container>
      </div>
      <Container className="tim-container">
        <div>
          <Row
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div className="typography-line">
              <h4>Students can train at both dojo’s at no extra cost</h4>
              <br />
              <p>
                <b>School Holidays:</b> December Holidays no classes, but all
                other holidays there will be classes.
              </p>
              <p>
                <b>Public Holidays:</b> No Classes.
              </p>
            </div>
          </Row>
        </div>
      </Container>
    </div>
  );
}

export default SectionClassTimes;
